import { axiosSuperAdmin, axiosUser } from '@axios/axiosInstances';

export const createAiPromptQuestion = body => axiosSuperAdmin.post('/ai-prompt-question', body);
export const getAiPromptQuestions = type =>
  axiosSuperAdmin.get('/ai-prompt-question', {
    params: {
      type
    }
  });
export const getAiPromptQuestionsForAdmin = type =>
  axiosUser.get(`/ai-prompt-question/admin`, {
    params: {
      type
    }
  });
export const updateAiPromptQuestion = (id, body) => axiosSuperAdmin.patch(`/ai-prompt-question/${id}`, body);
export const deleteAiPromptQuestion = id => axiosSuperAdmin.delete(`/ai-prompt-question/${id}`);
export const getAiPromptQuestionById = id => axiosSuperAdmin.get(`/ai-prompt-question/${id}`);

export const updateAiPromptQuestionOrder = (type, orderedIds) =>
  axiosSuperAdmin.post('/ai-prompt-question/reorder', {
    type,
    orderedIds
  });
